export const setDarkMode = () => dispatch => {
  return dispatch({ type: 'SET_DARK_MODE' })
}